import { updateShowDropAreaDeactivationOverlay } from "@src/reducers/your-reducer";
import store from "@src/reducers/store";

export const activateDropAreaOverlay = () => {
  store.dispatch(updateShowDropAreaDeactivationOverlay(true));
};
